<template>
  <router-link :class="$style.container" :to="`${base}/${source._id}`">
    <div :class="$style.header">
      <TextComponent :class="$style.title" type="heading4" color="teal" as="h2">
        {{ _index !== undefined ? `${_index + 1}. ` : ''
        }}{{ `${source.firstName} ${source.lastName}` }}
      </TextComponent>
      <TextComponent type="body2" as="span">
        <strong>
          {{ source.status.internalTextStatus }}
        </strong>
      </TextComponent>
    </div>
    <Stack direction="column" spacing="tad">
      <TextComponent :class="$style.text" type="body3">
        <Icon :class="$style.icon" name="paper-plane" />
        {{ source.email }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3">
        <Icon :class="$style.icon" name="hashtag" />
        {{ source._id }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3">
        <Icon :class="$style.icon" name="gavel" />
        Personal: {{ source.internal.computedApplicationScore }} | Final: {{ source.internal.computedFinalApplicationScore === undefined ? 'N/A' : source.internal.computedFinalApplicationScore }}
      </TextComponent>
    </Stack>
  </router-link>
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import Text from '@hackthe6ix/vue-ui/Text';
  import Icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/hashtag';
  import 'vue-awesome/icons/paper-plane';

  export default {
  name: 'ApplicantCard',
  components: {
    TextComponent: Text,
    Stack,
    Icon,
  },
  computed: {
    _index() {
      return this.source.index || this.index
    }
  },
  props: {
    base: {
      type: String,
      default: '',
    },
    index: Number,
    source: Object,
  },
};
</script>

<style lang="scss" module src="./ApplicantCard.module.scss" />
